export default __webpack_public_path__ + "static/media/facebook.15b74733.svg";